import styled from 'styled-components';
import DefaultAvatar from 'components/Avatar';
import DefaultStatus from 'components/Status';
import { FiMenu } from 'react-icons/fi';
import { TopBar } from 'components/StickyHeader';

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Container = styled(TopBar)``;

// TODO: TFR-45:Heading make unique name or do not export
export const Heading = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.navyGreen};
`;

// TODO: TFR-44 move to icon group
export const MenuIcon = styled(FiMenu)`
  font-size: 2rem;
  margin-right: 0.75rem;
  color: ${({ theme }) => theme.colors.navyGreen};
  :hover {
    cursor: pointer;
  }
`;

export const StatusButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  :hover {
    cursor: pointer;
  }
  :focus {
    outline: none;
  }
`;

export const OnSection = styled.div`
  display: flex;
  align-items: center;
`;

export const OffSection = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1rem;
`;

export const AvatarSection = styled.div`
  display: flex;
  align-items: center;
`;

export const Avatar = styled(DefaultAvatar)`
  width: 2rem;
  height: 2rem;
  filter: drop-shadow(0.125rem 0.0625rem 0.25rem rgba(169, 165, 171, 0.15));
  :not(:first-child) {
    margin-left: -1rem;
  }
`;

export const Status = styled(DefaultStatus)`
  margin-right: 0.5rem;
`;
